<script src="https://rawgit.com/vuejs-tips/v-money/master/dist/v-money.js"></script>
<template>
    <ul>
        <li>
            <p class="input-notice">진료비항목</p>
            <p> &nbsp; </p>
            <p class="input-notice">진료비(원)</p>
        </li>
        <li v-for="(record, idx) in value" :key="idx">
            <!-- <input type="text" :value="record"> -->
            <input type="text" :value="record.split('^')[0]" readonly>
            <p> : </p>
            <input type="text" :value="record.split('^')[1] | price_format" readonly>
            <button type="button" v-if="!no_price  && s_price.status < 4" class="profile-list-close-btn" @click="delprice(idx)"><img src="../../assets/home/del.png" alt="X" title="X"></button>
        </li>
        <!-- <li v-if="!no_price && s_price.status != 5"> -->
        <li v-if="!no_price && s_price.status < 4">
            <input class="new-item" type="text" v-model="new_item" ref="new_item_input"> 
            <p> : </p>
            <input class="new-price" type="text" v-model="initialCurrencyFormatted" maxlength="7" ref="new_price_input" @keydown="keyDown_numberOnly" @keyup="keyUp_numberOnly">
            <button type="button" class="profile-list-add-btn" @click="addPrice">추가</button>
        </li>
        <p class="h3Strong"> 진료비 합계 : {{sum_price | price_format}}원 </p>
        <p v-if="s_price.status==4 || s_price.status==5" class="signup-notice-red">* 진료비가 수납되어 진료비를 재청구할 수 없습니다.</p><br>
        <p v-if="s_price.status== 9" class="signup-notice-red signup-notice-left">* 진료가 취소되어 진료비를 (재)청구할 수 없습니다.</p><br>

        <!-- 추가서류 신청함 -->
        <!-- <div> -->
        <div v-if="document_object.document_apply_type == 1 || document_object.document_apply_type == 2">
          <h3 class="signup-notice">추가서류 (사용자 요청서류: {{document_object.document_code_name}})<span class="doc-status" v-if="document_object.document_apply_type == 2">* 수납상태 : {{document_object.document_status_name}}</span></h3>
          <br>
          <li>
              <!-- <input type="text" :value="record"> -->
              <input type="text" v-model="document_object.document_code_name" readonly>
              <p> : </p>
              <!-- <input type="number" v-model="document_object.document_price"> -->
              <input type="text" v-model="docInitialCurrencyFormatted">
              <!-- <button type="button" v-if="!no_price" class="profile-list-close-btn" @click="delprice(idx)"><img src="../../assets/home/del.png" alt="X" title="X"></button> -->
          </li>
          <p class="h3Strong"> 추가서류 합계 : {{document_object.document_price | price_format}}원 </p>
          <p v-if="document_object.document_status == 4 || document_object.document_status == 5" class="signup-notice-red">* 추가서류비용이 수납되어 재청구할 수 없습니다.</p><br>
        </div>
        
    </ul>
</template>

<script>
  import { nameByConstMixin } from '@/lib/mixins'
  export default {
    mixins: [nameByConstMixin],
    name: 'consult-price',
    props: ['value', 's_price', 'no_price', 'document_object'],
    data () {
      return {
        item_price: [],
        items: [],
        prices: [],
        new_item: "",
        new_price: "",
        sum_price: 0,

        //sum_price_view: 0, //사전신청일 경우 진료비와 추가서류 금액을 더해서 보여주기 위해 추가(실제 DB저장은 기존대로 진료비 합계만 저장하고 추가서류 금액은 따로 저장함)
      }
    },
    methods: {
      addPrice() {
        if(!this.new_item && !this.new_item.trim()){
          alert('빈값을 저장할 수 없습니다.');
          this.new_item = '';  
          this.$refs.new_item_input.focus();
          return;
        } else if(!this.new_price && !this.new_price.trim()) {
          alert('빈값을 저장할 수 없습니다.');
          this.new_price = '';  
          this.$refs.new_price_input.focus();
          return;
        }

        this.item_price = [...this.value];
        //console.log('add item_price0', this.item_price)
        //console.log('add prices0', this.prices)
        this.item_price.push(this.new_item + '^' + this.new_price);
        this.items.push(this.new_item);
        this.prices.push(this.new_price);
        // console.log('add item_price1', this.item_price)
        // console.log('add prices1', this.prices)
        // console.log('add sum_price0', this.sum_price)
        this.sum_price = Number(this.sum_price) + Number(this.new_price);
        //console.log('add sum_price1', this.sum_price)
        this.new_item = ''
        this.new_price = ''

        // //사전 신청일 경우
        // if(document_object.document_apply_type == '1'){
        //   this.sum_price_view = this.sum_price + this.document_object.document_price;
        // //사후 신청일 경우
        // }else if(document_object.document_apply_type == '2'){
        //   this.sum_price_view = this.document_object.document_price;
        // }

        this.$emit('input', this.item_price)
        this.$emit('set-consult-price', this.sum_price)
        this.$refs.new_item_input.focus();
      },
      delprice(idx) {
        this.item_price = [...this.value]
        //console.log('del item_price0', this.item_price)
        this.item_price.splice(idx, 1)
        // console.log('del item_price1', this.item_price)
        // console.log('idx', idx)
        // console.log('item_price', this.item_price)
        // console.log('sum_price0', this.sum_price)
        // console.log('prices0', this.prices)
        this.sum_price = this.sum_price - Number(this.prices[idx]);
        //console.log('sum_price1', this.sum_price)
        this.prices.splice(idx, 1);
        //console.log('prices', this.prices)
      
        this.$emit('input', this.item_price)
        this.$emit('set-consult-price', this.sum_price)
        this.$refs.new_item_input.focus();
      },
      formatAsCurrency (value, dec) {
        dec = dec || 0
        if (value === null || value === '') {
          return ''
        }
        var num = new Number(value);
        //console.log('formatAsCurrency', num.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))
        return '' + num.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
      },
      price_before() {
        let item = '';
        let price = '';
        this.items = [];
        this.prices = [];

        let price_value = this.value;
        for(let i=0;i<price_value.length;i++) {
          if(price_value[i]){
            item = price_value[i].split('^')[0];
            price = price_value[i].split('^')[1];

            this.items.push(item);
            this.prices.push(Number(price));
          }
        }        

        //console.log('price_before prices', this.prices);
      }
    },
    computed: {
      initialCurrencyFormatted: {
        get: function() {
          // if(this.new_price) return this.formatAsCurrency(this.new_price, 0);
          // else return '';
          if(this.new_price){
            return this.formatAsCurrency(this.new_price, 0);
            //return this.new_price;
          }else{
            return '';
          }
        },
        set: function(newValue) {
          this.new_price = newValue ? Number(newValue.replace(/[^0-9\.]/g, '')) : '';
        }
      },
      docInitialCurrencyFormatted: {
        get: function() {
          // 이거 제대로 작동 안한다
          // if(this.document_object.document_price){ //금액 청구 했으면
          //   return this.formatAsCurrency(this.document_object.document_price, 0);
          // }else{ //금액 청구 전이면
          //   return '';
          // }
          return this.formatAsCurrency(this.document_object.document_price, 0);
        },
        set: function(newValue) {
          this.document_object.document_price = newValue ? Number(newValue.replace(/[^0-9\.]/g, '')) : '';
        }
      }
    },
    async mounted () {
        // console.log('consultPrice 마운트됨!')
        // console.log('value', this.value)
        // console.log('prices', this.prices)
        if(this.s_price) this.sum_price = this.s_price.consult_price;
    },
    watch: {      
      value: function (value) {
        //console.log('Price value 변경됨(watch)', value)
      },
      s_price: function (s_price) {
        let s_price_sum = 0;
        //console.log('Price s_price 변경됨(watch)', s_price)
        if(!s_price && !s_price.consult_price) s_price = 0;
        else s_price = s_price.consult_price;

        let item = '';
        let price = '';
        let sum = 0;
        this.items = [];
        this.prices = [];

        //console.log('Price value', s_price);
        const ori_value = this.value;
        for(let i=0;i<ori_value.length;i++) {
          //console.log('v',value[i])
          if(ori_value[i]){
            item = ori_value[i].split('^')[0];
            price = ori_value[i].split('^')[1];

            this.items.push(item);
            this.prices.push(Number(price));

            sum = sum + Number(price);
          }
        }        

        //console.log('Price prices', this.prices);

        if(sum != Number(s_price)) this.sum_price = sum;
        else this.sum_price = s_price;

        this.$emit('set-consult-price', this.sum_price)
      },
      no_price: function (no_price) {
        if(no_price) { 
          this.sum_price = 0;
          this.$emit('set-consult-price', this.sum_price)
          this.items.push('진료비');
          this.prices.push(0);
         

        } else {
          this.sum_price = this.s_price.consult_price;
          this.$emit('input', this.value)
          this.$emit('set-consult-price', this.sum_price)

          let item = '';
          let price = '';
          this.items = [];
          this.prices = [];

          let price_value = this.value;
          for(let i=0;i<price_value.length;i++) {
            if(price_value[i]){
              item = price_value[i].split('^')[0];
              price = price_value[i].split('^')[1];

              this.items.push(item);
              this.prices.push(Number(price));
            }
          }
        }
      },
    },
  }
</script>

<style scoped>

    li {height: 40px; margin-bottom: 5px;}

    input {
        height: 35px;
        padding: 0 10px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .input-notice {
        width: 120px;
        text-align: center;
        border: 0px solid #d2d2d2;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .profile-list-add-btn {
        color: #fff;
        width: 60px;
        background-color: #736ee6;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    input {width: 45%;}
    li > input {width: 35%; height: 35px;}

    .new-price {
      float: left;
    }

    li > input, p,
    button {float: left;}

    li > p {height: 35px; padding: 0 10px; margin-top: 10px;}

    li > button {
        width: 30px;
        height: 35px;
        padding: 0;
        border: none;
        cursor: pointer;
        margin-left: 10px;
        position: relative;
        background-color: transparent;
    }

    .h3Strong {
        color: #4c4c4c;
        margin-bottom: 10px;
        letter-spacing: -.5px;
        font: 500 14px 'Noto Sans KR', sans-serif;
    }

    .doc-status {
      float: right;
      color: #484848;
      /* margin: 0; */
      margin-right: 20px;
      font: 400 14px 'Noto Sans KR', sans-serif;
    }

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .signup-notice {
        /* text-align:left; */
        color: #484848;
        margin-top: 50px;
        margin-left: 10px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .signup-notice-red {
        color: #ee0000;
        /* margin: 0; */
        margin-top: 30px;
        font: 400 12px 'Noto Sans KR', sans-serif;
        float: right;
        margin-right: 20px;
    }

    .signup-notice-left {
      text-align:left;
    }

</style>